var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArttIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5006 2H5.50055C5.50055 2 5.27079 3.85118 5.50055 5C5.96685 7.33148 8.59558 9.4062 10.0435 10.3923C10.625 10.7883 11.3761 10.7883 11.9576 10.3923C13.4055 9.4062 16.0343 7.33148 16.5006 5C16.7303 3.85118 16.5006 2 16.5006 2Z",
    stroke: "#FF9F0A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5006 20H5.50055C5.50055 20 5.27079 18.1488 5.50055 17C5.96685 14.6685 8.59558 12.5938 10.0435 11.6077C10.625 11.2117 11.3761 11.2117 11.9576 11.6077C13.4055 12.5938 16.0343 14.6685 16.5006 17C16.7303 18.1488 16.5006 20 16.5006 20Z",
    stroke: "#FF9F0A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9622 17.5C13.9622 17.7761 13.7384 18 13.4622 18H8.53516C8.25901 18 8.03516 17.7761 8.03516 17.5V17.2118C8.03516 17.071 8.0424 16.9263 8.10819 16.8018C8.52821 16.0069 10.3189 15.6234 10.8498 15.5257C10.9493 15.5074 11.0481 15.5074 11.1476 15.5257C11.6785 15.6234 13.4692 16.0069 13.8892 16.8018C13.955 16.9263 13.9622 17.071 13.9622 17.2118V17.5Z",
    fill: "#FF9F0A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6536 6C9.33529 6 9.10907 6.29655 9.28546 6.56151C9.61145 7.05119 10.1585 7.4687 10.5467 7.7258C10.8228 7.9087 11.1746 7.9087 11.4507 7.7258C11.8389 7.4687 12.3859 7.05119 12.7119 6.56151C12.8883 6.29655 12.6621 6 12.3438 6H9.6536Z",
    fill: "#FF9F0A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2H3.5",
    stroke: "#FF9F0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20H3.5",
    stroke: "#FF9F0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArttIcon);
export default __webpack_public_path__ + "static/media/artt-icon.c871f4c7f7e2b7dab034f34f83680c2c.svg";
export { ForwardRef as ReactComponent };